export default function () {
	return {
		showDiscountRequestModal: false,

		init() {
			this.attachEvents()
		},

		attachEvents() {
			jQuery('form.variations_form').on('woocommerce_variation_has_changed, show_variation', (event, variation) => {
				this.variationChanged(event, variation)
			})
		},

		variationChanged(event, variation) {
			if (this.$root.querySelector('.price-container')) {
				this.$root.querySelector('.price-container').outerHTML = variation.price_html
			}

			if (this.$root.querySelector('.stock-container')) {
				this.$root.querySelector('.stock-container').outerHTML = variation.availability_html
			}
		},

		openDiscountRequestModal() {
			this.showDiscountRequestModal = true
			document.body.classList.add('has-overlay')
		},

		closeDiscountRequestModal() {
			this.showDiscountRequestModal = false
			document.body.classList.remove('has-overlay')
		},
	}
}
